"use client"

import { OAuthButton } from "@/components/auth/oauth-button"

/**
 * Sign in with Apple.
 *
 * Required, not optional: App Store guideline 4.8 says an app offering a
 * third-party login service for account setup must also offer one that
 * limits collection to name and email, lets people keep their email
 * private, and doesn't collect interactions for advertising. Google does
 * not meet that; Sign in with Apple does. Offering email and password
 * alongside is not an exemption, because Google is still a primary route in.
 *
 * Apple's Human Interface Guidelines ask that the button be no less
 * prominent than the other sign-in options, so it renders in the same
 * shape and size as Google and sits directly above it.
 */

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" fill="currentColor">
    <path d="M17.05 12.54c-.02-2.3 1.88-3.4 1.96-3.45-1.07-1.56-2.73-1.78-3.32-1.8-1.41-.14-2.76.83-3.48.83-.72 0-1.83-.81-3.01-.79-1.55.02-2.98.9-3.78 2.29-1.61 2.8-.41 6.95 1.16 9.22.77 1.11 1.68 2.36 2.88 2.31 1.16-.05 1.6-.75 3-.75 1.4 0 1.79.75 3.01.72 1.24-.02 2.03-1.13 2.79-2.25.88-1.29 1.24-2.54 1.26-2.6-.03-.01-2.42-.93-2.44-3.69zM14.78 5.2c.64-.78 1.07-1.85.95-2.93-.92.04-2.03.61-2.69 1.38-.59.69-1.11 1.79-.97 2.84 1.03.08 2.07-.52 2.71-1.29z" />
  </svg>
)

type AppleAuthButtonProps = {
  label: string
  /** Shown if the OAuth redirect fails before leaving the page. */
  errorFallback: string
  /** Carried through the OAuth redirect so /auth/callback can assign it on first sign-in. */
  role?: "barber" | "owner" | "client"
  /** Persisted to localStorage before redirecting so the invite survives the OAuth round-trip. */
  inviteToken?: string | null
  /** Where to land after sign-in, e.g. the chair the visitor picked. */
  redirect?: string | null
  onError?: (message: string) => void
}

export function AppleAuthButton(props: AppleAuthButtonProps) {
  return <OAuthButton provider="apple" icon={<AppleIcon />} {...props} />
}
